import React from 'react';
import icon from '../../assets/applogo.jpg';
import { FaPhone, FaSmile, FaMicrophone, FaRegHeart } from "react-icons/fa";
import { IoMdVideocam, IoIosSend } from "react-icons/io";
import { MdPhotoSizeSelectActual } from "react-icons/md";
import { RiInformationFill } from "react-icons/ri";
import styles from './ChatWindow.module.css';

const ChatWindow = ({ user }) => {
  if (!user) {
    return (
      <div className={styles.chatWindowEmpty}>
        <img src={icon} alt="Chat Icon" className={styles.emptyIllustration} />
      </div>
    );
  }

  return (
    <div className={styles.chatWindow}>
      <header className={styles.chatHeader}>
        <div className={styles.headerLeft}>
          <img src={user.profile} alt={user.name} className={styles.headerAvatar} />
          <div className={styles.headerInfo}>
            <h3 className={styles.headerName}>{user.name}</h3>
            <p className={styles.headerStatus}>
              <span className={styles.statusIndicator}></span>
              Last seen {user.lastSeen}
            </p>
          </div>
        </div>
        <div className={styles.headerRight}>
          <div className={styles.headerIcon}>
            <FaPhone />
          </div>
          <div className={styles.headerIcon}>
            <IoMdVideocam />
          </div>
          <div className={styles.headerIcon}>
            <RiInformationFill />
          </div>
        </div>
      </header>

      <main className={styles.chatMain}>
        <div className={styles.profileSection}>
          <img src={user.profile} alt={user.name} className={styles.profileAvatar} />
          <h4 className={styles.profileName}>{user.name}</h4>
          <p className={styles.profileRole}>{user.role}</p>
          <button className={styles.profileButton}>View Profile</button>
        </div>

        <div className={styles.messagesContainer}>
          <div className={`${styles.message} ${styles.messageSent}`}>
            <p className={styles.messageText}>Hello! How are you doing today?</p>
            <div className={styles.messageTime}>12:00 AM</div>
          </div>
          <div className={`${styles.message} ${styles.messageReceived}`}>
            <p className={styles.messageText}>I'm doing great, thanks for asking! How about you?</p>
            <div className={styles.messageTime}>12:02 AM</div>
          </div>
          <div className={`${styles.message} ${styles.messageSent}`}>
            <p className={styles.messageText}>I'm good too. Are you available for a project this week?</p>
            <div className={styles.messageTime}>12:05 AM</div>
          </div>
          <div className={`${styles.message} ${styles.messageReceived}`}>
            <p className={styles.messageText}>Yes, I have some availability. What do you need help with?</p>
            <div className={styles.messageTime}>12:07 AM</div>
          </div>
        </div>
      </main>

      <footer className={styles.chatFooter}>
        <FaSmile className={styles.footerIcon} />
        <div className={styles.attachmentIcons}>
          <FaMicrophone className={styles.footerIcon} />
          <MdPhotoSizeSelectActual className={styles.footerIcon} />
          <FaRegHeart className={styles.footerIcon} />
        </div>
        <input
          type="text"
          placeholder="Write a message..."
          className={styles.messageInput}
        />
        <button className={styles.sendButton}>
          <IoIosSend size={20} />
        </button>
      </footer>
    </div>
  );
};

export default ChatWindow;